import { Box, Divider, Stack, Typography } from '@mui/material';
import { Field, FormikHelpers } from 'formik';
import { TextField } from 'formik-mui';
import { FormValues, validate } from './company-dialog.form';
import { FormDialog } from 'shared/ui/form-dialog';
import { CompanyTypesCheckboxes } from 'entities/company/company-type-field';
import { ContactsListField } from 'features/contacts-form-field';
import { useStateSelector } from 'shared/store';
import { CityPicker } from '../../../entities/geo/cities/city-picker';
import { OkvedPickerField } from 'entities/okved/okved-picker/okved-picker';

export interface DialogProps<T> {
  open: boolean;
  onClose: () => void;
  onSubmit: (newCompanyData: T) => Promise<void>;
}

interface CoreDialogProps {
  title: string;
  isCreateMode?: boolean;
  open: boolean;
  onClose: () => void;
  handleSubmit: (values: FormValues, helpers?: FormikHelpers<FormValues>) => Promise<void>;
  formInitialValues: () => FormValues;
}

export const CompanyDialogCore = ({ open, onClose, handleSubmit, title, formInitialValues, isCreateMode }: CoreDialogProps) => {
  const isDupesCheckInprogress = useStateSelector((state) => state.ui.dupesIndication.isDupesCheckInProgress);
  const hasAnyContacts = (contacts: FormValues['companyContacts'] | undefined) => {
    if (!contacts) return false;
    return contacts.linkedEmails.length > 0 || contacts.linkedPhones.length > 0 || contacts.linkedUrls.length > 0;
  };
  const validateForm = async (values: FormValues) => {
    const errors = await validate(values);
    if (isCreateMode && !hasAnyContacts(values.companyContacts)) {
      errors.companyContacts = { linkedEmails: 'Добавьте хотя бы один контакт' };
    }
    return errors;
  };

  return (
    <FormDialog
      onClose={onClose}
      open={open}
      dialogProps={{ maxWidth: 'md', fullWidth: true }}
      renderTitle={title}
      onSubmit={handleSubmit}
      validate={validateForm}
      initialValues={formInitialValues()}
      validateOnChange
      options={{ disableOkButton: isDupesCheckInprogress }}
      renderForm={(formikProps) => (
        <Stack direction="column" spacing={2}>
          <Field component={TextField} name="name" label="Название" sx={{ mt: 1 }} />
          <Box flexGrow={1}>
            <Field component={CityPicker} name="cityId" label="Город" />
          </Box>
          <Box flexGrow={1}>
            <Field component={OkvedPickerField} name="okvedIds" label="ОКВЭД" />
          </Box>          
          <Stack direction="row" spacing={1} justifyContent="space-between">
            <Box flexGrow={1}>
              <Field component={CompanyTypesCheckboxes} name="companyType"/>
            </Box>

            {isCreateMode && (
              <>
                <Box>
                  <Divider orientation="vertical" />
                </Box>
                <Box flexGrow={1}>
                  <Field name="companyContacts" component={ContactsListField} />
                  {!hasAnyContacts(formikProps.values.companyContacts) && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                      Добавьте хотя бы один контакт, чтобы сохранить фирму.
                    </Typography>
                  )}
                </Box>
              </>
            )}
          </Stack>
        </Stack>
      )}
    />
  );
};
